import React, { createContext, useContext, useMemo } from 'react';

import { DEFAULT_LOCALE, type LocaleCode } from './locales';
import { createTranslator } from './t';
import type { Translate } from './types';

const LocaleContext = createContext<LocaleCode>(DEFAULT_LOCALE);

export const LocaleProvider: React.FC<{ locale?: LocaleCode; children: React.ReactNode }> = ({
  locale = DEFAULT_LOCALE,
  children,
}) => <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;

export const useLocale = (): LocaleCode => useContext(LocaleContext);

/** Locale-aware `t()`. Use in components so copy updates when the locale changes. */
export const useTranslation = (): Translate => {
  const locale = useLocale();
  return useMemo(() => createTranslator(locale), [locale]);
};
